import StdListContext from 'contexts/StdListContext';
import React from 'react';

interface Props {
  children?: React.ReactNode;
}

class StdListHeader extends React.Component<Props> {
  render(): React.ReactNode {
    const { children } = this.props;
    return (
      <StdListContext.Consumer>
        {({ id, gridTemplateColumns }): React.ReactNode => (
          <div
            id={`${id}-header`}
            className="std-list-header shrink-0 w100 hs3 bgd-light-grey-2 bb-3"
            style={{
              display: 'grid',
              gridTemplateColumns,
              gridTemplateRows: 'auto',
              alignItems: 'center',
              borderRadius: '8px 8px 0 0',
            }}
          >
            {children}
          </div>
        )}
      </StdListContext.Consumer>
    );
  }
}

export default StdListHeader;
